import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { Popover } from 'antd'
import { loadApplications } from 'redux/appList/actions'

class AppSwitcher extends Component {
    componentDidMount() {
        const { loadApplications } = this.props

        loadApplications()
    }

    render() {
        const { currentApp, applicationList } = this.props

        const applicationPopoverContent = (
            <ul className="gx-user-popover">
                {applicationList.map((application, index) => {
                    return (
                        <Link key={index} to={`/${application.id}/dashboard`}>
                            <li>{application.name}</li>
                        </Link>
                    )
                })}
            </ul>
        )

        if (this.props.show) {
            return (
                <Popover placement="bottomRight" content={applicationPopoverContent} trigger="click">
                    <span className="gx-avatar-name">
                        {currentApp.name}
                        <i className="icon icon-chevron-down gx-fs-xxs gx-ml-2" />
                    </span>
                </Popover>
            )
        }
        return null
    }
}

const mapStateToProps = ({ appList, ekko }) => ({
    applicationList: appList.applicationList,
    currentApp: ekko.currentApp
})

const mapActionsToProps = dispatch => ({
    loadApplications: bindActionCreators(loadApplications, dispatch)
})

export default connect(
    mapStateToProps,
    mapActionsToProps
)(AppSwitcher)

// <Link to={`/${id}/dashboard`}>
//     <Button type="primary">Manage</Button>
// </Link>
